import { selector } from "recoil"
import apiService from "../services/api"

export const iconsAllSelector = selector<string[]>({
    key: 'iconsAllSelector',
    get: async () => {
        var rv = await apiService.getAllIcons()
        return rv ?? []
    }
})
